import React from "react";
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/select";
import { DashboardTimeFilter } from "../types/dashboard-ui.types";

interface DashboardAnalyticsHeaderProps {
  timeFilter: DashboardTimeFilter;
  onTimeFilterChange: (value: DashboardTimeFilter) => void;
}

export const DashboardAnalyticsHeader: React.FC<
  DashboardAnalyticsHeaderProps
> = ({ timeFilter, onTimeFilterChange }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between mb-6 mt-10">
      <h2
        className="text-xl text-[#004232] dark:text-white"
        style={{ fontFamily: "Cal Sans" }}
      >
        {t("dashboard.charts.analytics")}
      </h2>
      <Select value={timeFilter} onValueChange={onTimeFilterChange}>
        <SelectTrigger className="w-[180px] bg-white dark:bg-gray-800">
          <SelectValue placeholder={t("dashboard.charts.time_filter.this_week")} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="this_week">
            {t("dashboard.charts.time_filter.this_week")}
          </SelectItem>
          <SelectItem value="this_month">
            {t("dashboard.charts.time_filter.this_month")}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
